export default "/static/webpack/media/arrow-down.46f6edd5.svg";